// src/components/common/Logo.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Logo = ({ variant = "default" }) => {
  return (
    <Box
      component={Link}
      to="/"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        textDecoration: "none",
        color: "inherit",
        transition: "transform 0.2s ease",
        "&:hover": {
          transform: "scale(1.02)",
        },
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          background: "#8cc61d",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontWeight: 700,
          fontSize: "1.4rem",
          boxShadow: "0 4px 12px rgba(140, 198, 29, 0.3)",
          transition: "box-shadow 0.2s ease",
          "&:hover": {
            boxShadow: "0 6px 20px rgba(140, 198, 29, 0.4)",
          },
        }}
      >
        <span style={{ transform: "rotate(12deg)" }}>⟡</span>
      </Box>
      <Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            lineHeight: 1.2,
            color: "#0b1a2e",
            fontSize: "1.25rem",
            letterSpacing: "-0.01em",
          }}
        >
          Wavelength
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            fontSize: "0.6rem",
            fontWeight: 500,
            letterSpacing: "0.5px",
            color: "#3f5a79",
            marginTop: "-2px",
            textTransform: "uppercase",
          }}
        >
          consultancy solutions
        </Typography>
      </Box>
    </Box>
  );
};

export default Logo;
